import queryString from 'query-string';
import compact from 'lodash/compact';
import toLower from 'lodash/toLower';

const parseParams = () => {
  const parsedQueryString = queryString.parse(window.location.search);
  const {
    groupId, programId, print, client, userId, providerId, lat, lon,
  } = parsedQueryString;
  const printOnLoad = toLower(print) === 'true';
  const programIds = programId ? compact(programId.split(',')) : [];
  const groupIds = groupId ? compact(groupId.split(',')) : [];
  const { language = 'en' } = parsedQueryString;

  return {
    groupIds,
    programIds,
    printOnLoad,
    client,
    userId,
    language,
    providerId,
    lat,
    lon,
  };
};

export default parseParams;
